// extracted by mini-css-extract-plugin
module.exports = {"nav__locale-btn--country":"NavLocaleCountry_nav__locale-btn--country__TIJUg","nav__country-title":"NavLocaleCountry_nav__country-title__dhlJ3"};